document.addEventListener("DOMContentLoaded", function () {
  var checkoutUrl = "/checkout";
  var redirectKey = "guest-checkout-redirect";
  var redirectLocalKey = "guest-checkout-redirect-local";
  var redirectCookie = "guest_checkout_redirect";
  var redirectTimestampKey = "guest-checkout-redirect-ts";
  var pendingCheckoutKey = "guest-checkout-item";
  var redirectStartedAt = null;
  var redirectCookieMaxAge = 180;
  var redirectTtlMs = 60000;

  var isLoggedIn = document.body.getAttribute("data-customer-logged-in") === "true";

  try {
    if (
      isLoggedIn &&
      (sessionStorage.getItem(redirectKey) === "1" ||
        localStorage.getItem(redirectLocalKey) === "1" ||
        readCookie(redirectCookie) === "1")
    ) {
      sessionStorage.removeItem(redirectKey);
      localStorage.removeItem(redirectLocalKey);
      localStorage.removeItem(redirectTimestampKey);
      clearCookie(redirectCookie);
      addPendingItemThenCheckout();
      return;
    }
    var storedTimestamp = localStorage.getItem(redirectTimestampKey);
    if (storedTimestamp) {
      var parsedTimestamp = parseInt(storedTimestamp, 10);
      if (!parsedTimestamp || Date.now() - parsedTimestamp > redirectTtlMs) {
        sessionStorage.removeItem(redirectKey);
        localStorage.removeItem(redirectLocalKey);
        localStorage.removeItem(redirectTimestampKey);
        clearCookie(redirectCookie);
      }
    }
  } catch (e) {
    // Ignore storage errors.
  }

  var modal = document.querySelector("[data-guest-checkout-modal]");
  if (!modal) return;

  var activeClass = "is-active";
  var body = document.body;
  var authCheckPending = false;
  var checkoutConfirmPending = false;
  var loginCheckDelay = 300;
  var checkoutConfirmDelay = 500;
  var checkoutConfirmAttempts = 0;
  var checkoutConfirmMaxAttempts = 2;
  var authAttempted = false;
  var pendingCheckoutItem = null;
  var pendingCheckoutHandled = false;
  var modalOpenedAt = null;

  function readCookie(name) {
    var match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function writeCookie(name, value, maxAgeSeconds) {
    var cookieValue = encodeURIComponent(value);
    var cookie = name + "=" + cookieValue + "; Path=/; SameSite=Lax";
    if (typeof maxAgeSeconds === "number") {
      cookie += "; Max-Age=" + Math.floor(maxAgeSeconds);
    }
    document.cookie = cookie;
  }

  function clearCookie(name) {
    document.cookie = name + "=; Path=/; Max-Age=0; SameSite=Lax";
  }

  function hasRedirectFlag() {
    return (
      sessionStorage.getItem(redirectKey) === "1" ||
      localStorage.getItem(redirectLocalKey) === "1" ||
      readCookie(redirectCookie) === "1"
    );
  }

  var setRedirectFlag = function () {
    redirectStartedAt = Date.now();
    try {
      sessionStorage.setItem(redirectKey, "1");
    } catch (e) {
      // Ignore storage errors.
    }
    try {
      localStorage.setItem(redirectLocalKey, "1");
    } catch (e) {
      // Ignore storage errors.
    }
    try {
      localStorage.setItem(redirectTimestampKey, String(redirectStartedAt));
    } catch (e) {
      // Ignore storage errors.
    }
    try {
      writeCookie(redirectCookie, "1", redirectCookieMaxAge);
    } catch (e) {
      // Ignore cookie errors.
    }
    try {
      console.log(
        "[guest-checkout-debug]",
        "set flag",
        sessionStorage.getItem(redirectKey),
        "local:",
        localStorage.getItem(redirectLocalKey),
        "cookie-flag:",
        readCookie(redirectCookie),
        "cookie:",
        document.cookie
      );
    } catch (e) {
      // Ignore storage errors.
    }
  };

  var clearRedirectFlag = function () {
    redirectStartedAt = null;
    try {
      sessionStorage.removeItem(redirectKey);
    } catch (e) {
      // Ignore storage errors.
    }
    try {
      localStorage.removeItem(redirectLocalKey);
    } catch (e) {
      // Ignore storage errors.
    }
    try {
      localStorage.removeItem(redirectTimestampKey);
    } catch (e) {
      // Ignore storage errors.
    }
    try {
      clearCookie(redirectCookie);
    } catch (e) {
      // Ignore cookie errors.
    }
  };

  var checkLoginStatus = function () {
    if (authCheckPending) return;
    if (!hasRedirectFlag()) return;
    authCheckPending = true;
    fetch("/account", { credentials: "same-origin" })
      .then(function (response) {
        authCheckPending = false;
        var finalUrl = response.url || "";
        var loggedInNow =
          finalUrl.indexOf("/account/login") === -1 && finalUrl.indexOf("/account/register") === -1;
        if (loggedInNow) {
          confirmLoginThenCheckout();
          return;
        }
        if (redirectStartedAt && Date.now() - redirectStartedAt < redirectTtlMs) {
          setTimeout(checkLoginStatus, loginCheckDelay);
          return;
        }
        clearRedirectFlag();
      })
      .catch(function () {
        authCheckPending = false;
        if (redirectStartedAt && Date.now() - redirectStartedAt < redirectTtlMs) {
          setTimeout(checkLoginStatus, loginCheckDelay);
          return;
        }
        clearRedirectFlag();
      });
  };

  var confirmLoginThenCheckout = function () {
    if (checkoutConfirmPending) return;
    checkoutConfirmPending = true;
    setTimeout(function () {
      fetch("/account", { credentials: "same-origin" })
        .then(function (response) {
          checkoutConfirmPending = false;
          var finalUrl = response.url || "";
          var loggedInNow =
            finalUrl.indexOf("/account/login") === -1 &&
            finalUrl.indexOf("/account/register") === -1;
          if (loggedInNow) {
            clearRedirectFlag();
            addPendingItemThenCheckout();
            return;
          }
          checkoutConfirmAttempts += 1;
          if (checkoutConfirmAttempts < checkoutConfirmMaxAttempts) {
            confirmLoginThenCheckout();
            return;
          }
          if (redirectStartedAt && Date.now() - redirectStartedAt < redirectTtlMs) {
            setTimeout(checkLoginStatus, loginCheckDelay);
            return;
          }
          clearRedirectFlag();
        })
        .catch(function () {
          checkoutConfirmPending = false;
          checkoutConfirmAttempts += 1;
          if (checkoutConfirmAttempts < checkoutConfirmMaxAttempts) {
            confirmLoginThenCheckout();
            return;
          }
          if (redirectStartedAt && Date.now() - redirectStartedAt < redirectTtlMs) {
            setTimeout(checkLoginStatus, loginCheckDelay);
            return;
          }
          clearRedirectFlag();
        });
    }, checkoutConfirmDelay);
  };

  if (isLoggedIn) return;

  var openModal = function () {
    if (modal.classList.contains(activeClass)) return;
    modal.classList.add(activeClass);
    modal.setAttribute("aria-hidden", "false");
    body.classList.add("guest-checkout-open");
    authAttempted = false;
    modalOpenedAt = Date.now();
    var firstInput = modal.querySelector("[data-guest-checkout-panel].is-active input");
    if (firstInput) firstInput.focus();
  };

  var closeModal = function () {
    if (!modal.classList.contains(activeClass)) return;
    modal.classList.remove(activeClass);
    modal.setAttribute("aria-hidden", "true");
    body.classList.remove("guest-checkout-open");
    if (!authAttempted) {
      clearRedirectFlag();
    }
    if (!authAttempted) {
      pendingCheckoutItem = null;
      pendingCheckoutHandled = false;
    }
  };

  var setPendingCheckoutItem = function (form) {
    if (!form) return;
    var idInput = form.querySelector("[name='id']");
    if (!idInput || !idInput.value) return;
    var qtyInput = form.querySelector("[name='quantity']");
    var quantity = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1;
    if (!quantity || Number.isNaN(quantity)) quantity = 1;
    pendingCheckoutItem = {
      id: idInput.value,
      quantity: quantity,
    };
    try {
      localStorage.setItem(pendingCheckoutKey, JSON.stringify(pendingCheckoutItem));
    } catch (e) {
      // Ignore storage errors.
    }
    pendingCheckoutHandled = false;
  };

  var addPendingItemThenCheckout = function () {
    if (!pendingCheckoutItem) {
      try {
        var stored = localStorage.getItem(pendingCheckoutKey);
        if (stored) pendingCheckoutItem = JSON.parse(stored);
      } catch (e) {
        // Ignore storage errors.
      }
    }
    if (!pendingCheckoutItem || pendingCheckoutHandled) {
      location.assign(checkoutUrl);
      return;
    }
    pendingCheckoutHandled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(pendingCheckoutItem),
    })
      .then(function () {
        try {
          localStorage.removeItem(pendingCheckoutKey);
        } catch (e) {
          // Ignore storage errors.
        }
        location.assign(checkoutUrl);
      })
      .catch(function () {
        try {
          localStorage.removeItem(pendingCheckoutKey);
        } catch (e) {
          // Ignore storage errors.
        }
        location.assign(checkoutUrl);
      });
  };

  var switchTab = function (target) {
    var tabs = modal.querySelectorAll("[data-guest-checkout-tab]");
    var panels = modal.querySelectorAll("[data-guest-checkout-panel]");
    tabs.forEach(function (tab) {
      tab.classList.toggle(activeClass, tab.getAttribute("data-guest-checkout-tab") === target);
    });
    panels.forEach(function (panel) {
      panel.classList.toggle(activeClass, panel.getAttribute("data-guest-checkout-panel") === target);
    });
  };

  modal.addEventListener("click", function (event) {
    var tab = event.target.closest("[data-guest-checkout-tab]");
    if (tab) {
      switchTab(tab.getAttribute("data-guest-checkout-tab"));
    }

    var guestCheckout = event.target.closest("[data-guest-checkout-guest]");
    if (guestCheckout && modal.contains(guestCheckout)) {
      event.preventDefault();
      clearRedirectFlag();
      addPendingItemThenCheckout();
      return;
    }

    var hikoButton = event.target.closest(".h_line_button, .h_google_button");
    if (hikoButton && modal.contains(hikoButton)) {
      authAttempted = true;
      setRedirectFlag();
    }
  });

  modal.querySelectorAll("[data-guest-checkout-close]").forEach(function (el) {
    el.addEventListener("click", function () {
      closeModal();
    });
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeModal();
    }
  });

  window.addEventListener("focus", function () {
    if (!isLoggedIn && redirectStartedAt) {
      checkLoginStatus();
    }
  });

  document.addEventListener("visibilitychange", function () {
    if (!document.hidden && !isLoggedIn && redirectStartedAt) {
      checkLoginStatus();
    }
  });

  var isCheckoutTrigger = function (element) {
    if (!element) return false;
    if (element.matches("[data-guest-checkout-trigger]")) return true;
    if (element.matches("button[name='checkout'], input[name='checkout']")) return true;
    if (element.matches(".shopify-payment-button__button")) return true;
    if (element.matches(".tp-product-buy-now-btn")) return true;
    return false;
  };

  document.addEventListener(
    "click",
    function (event) {
    var trigger = event.target.closest("button, input");
    if (!isCheckoutTrigger(trigger)) return;
    if (modal.contains(trigger)) return;
    if (trigger && trigger.matches(".tp-product-buy-now-btn")) {
      setPendingCheckoutItem(trigger.closest("form"));
    }
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }
    openModal();
    },
    true
  );

  document.addEventListener(
    "submit",
    function (event) {
    var submitter = event.submitter || document.activeElement;
    if (!isCheckoutTrigger(submitter)) return;
    if (modal.contains(submitter)) return;
    if (submitter && submitter.matches(".tp-product-buy-now-btn")) {
      setPendingCheckoutItem(submitter.closest("form"));
    }
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }
    openModal();
    },
    true
  );

  modal.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !modal.contains(form)) return;
    var formTypeInput = form.querySelector("input[name='form_type']");
    if (!formTypeInput) return;
    var formTypeValue = formTypeInput.value;
    if (formTypeValue !== "customer_login" && formTypeValue !== "create_customer") return;
    authAttempted = true;
    setRedirectFlag();
  });

  setInterval(function () {
    if (!modalOpenedAt) return;
    if (authAttempted) return;
    if (Date.now() - modalOpenedAt < redirectTtlMs) return;
    clearRedirectFlag();
    modalOpenedAt = null;
  }, 1000);
});
